export default "__VITE_ASSET__BFIEED3s__"